import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource-variable/inter';
import './styles/tokens.base.css';
import './styles/shell.css';
import { App } from './App';

const root = document.getElementById('root');
if (!root) throw new Error('#root missing');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// §7.6 / D-029 — the offline shell. Registered only in a built bundle: the worker precaches
// hashed asset names that exist nowhere else, and a worker in front of the dev server would
// serve yesterday's module graph over today's edit.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js').catch((error: unknown) => {
      // A refused registration is not a broken desktop — everything still works online.
      console.warn('service worker registration failed', error);
    });
  });
}
